import PropTypes from 'prop-types';
var Panel = PropTypes.shape({
  state: PropTypes.shape({
    panelState: PropTypes.shape({})
  })
});
var LinkPoint = PropTypes.shape({
  panelId: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  columnType: PropTypes.string.isRequired
});
var LinkPointUntyped = PropTypes.shape({
  panelId: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired
});
var Link = PropTypes.shape({
  start: LinkPointUntyped,
  end: LinkPointUntyped,
  id: PropTypes.string,
  isReversed: PropTypes.bool
});
var Links = PropTypes.arrayOf(Link);
var User = PropTypes.shape({
  name: PropTypes.string.isRequired,
  operateAs: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(PropTypes.string).isRequired,
  permissions: PropTypes.shape({
    canUsePanels: PropTypes.bool.isRequired,
    canCopy: PropTypes.bool.isRequired,
    canDownloadCsv: PropTypes.bool.isRequired,
    canLogout: PropTypes.bool.isRequired
  }).isRequired
});
var UIPropTypes = Object.freeze({
  LinkPoint,
  Link,
  Links,
  Panel,
  User
});
export default UIPropTypes;
//# sourceMappingURL=UIPropTypes.js.map